import React from "react";
import usePricing from "./usePricing";
import { useLocation } from "react-router-dom";

const DealerLogin = () => {
  const { pricingEnabled, disablePricing } = usePricing();
  const location = useLocation();

  if (pricingEnabled) {
    return (
      <button
        onClick={disablePricing}
        style={{
          marginLeft: "0.5rem",
          color: "#fff",
          textDecoration: "underline",
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          font: "inherit",
        }}
      >
        Logout
      </button>
    );
  }

  const url = `${process.env.REACT_APP_PORTAL_URL}/quotes/chair-builder?redirect=${location.pathname}${location.search}`;

  return (
    <a href={url} style={{ marginLeft: "0.5rem", color: "#fff", textDecoration: "underline" }}>
      Dealer Login
    </a>
  );
};

export default DealerLogin;
